export default "__VITE_ASSET__CGkvd$aN__"